// Copyright (C) The Arvados Authors. All rights reserved.
//
// SPDX-License-Identifier: AGPL-3.0

import React from "react";
import { ListItemIcon, ListItemText, ListItem } from "@mui/material";
import { Link } from "components/icon/icon";

interface CopyToClipboardActionProps {
    href?: any;
    kind?: string;
    customText?: string;
    onClick?: () => void;
};

export const CopyToClipboardAction = (props: CopyToClipboardActionProps) => {
    const copyToClipboard = () => {
        (props.href
            ? navigator.clipboard.writeText(props.href)
            : Promise.resolve()
        ).finally(() => {
            if (props.onClick) props.onClick();
        });
    };

    return props.href
         ? <ListItem button onClick={copyToClipboard}>
             <ListItemIcon>
                 <Link />
             </ListItemIcon>
             <ListItemText>
                 {props.customText ? props.customText : "Copy link to clipboard"}
             </ListItemText>
         </ListItem>
         : null;
};
